import { render } from "./ProjectsSection.vue?vue&type=template&id=ac3b0e9a&scoped=true"
import script from "./ProjectsSection.vue?vue&type=script&lang=js"
export * from "./ProjectsSection.vue?vue&type=script&lang=js"

import "./ProjectsSection.vue?vue&type=style&index=0&id=ac3b0e9a&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac3b0e9a"]])

export default __exports__